//cookie操作
import QS from 'qs'
function getsec(str) {
  if (str == undefined) {
    return str
  }
  if (str == -1) {
    return str
  }
  var str1 = str.substring(1, str.length) * 1;
  var str2 = str.substring(0, 1);
  if (str2 == "s") {
    return str1 * 1000;
  } else if (str2 == "h") {
    return str1 * 60 * 60 * 1000;
  } else if (str2 == "d") {
    return str1 * 24 * 60 * 60 * 1000;
  }
}
export function getCookie(name) {
  var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if (arr = document.cookie.match(reg))
    return unescape(arr[2]);
  else
    return null;
}
export function delCookie(name) {
  /*  setCookie(name, null, -1);*/
  var strsec = getsec(-1);
  var exp = new Date();
  exp.setTime(exp.getTime() + strsec * 1);
  document.cookie = name + "=" + escape(null) + ";expires=" + exp.toGMTString() + "; path=/";
}
export function setCookie(name, value, time) {
  var strsec = getsec(time);
  var exp = new Date();
  exp.setTime(exp.getTime() + strsec * 1);
  document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString() + "; path=/";
}
import axios from 'axios'
// 统计
export function statPushPost(params) {
  var _this = this;
  // if (process.env.NODE_ENV == 'development') {
  //   return false;
  // }
  console.log(window.location.href,'11111');
  
  if (!params) {
    params = {
      "url": window.location,
      'appSecret': '7E9BBDC660A59FA74868A2A9CE74C436',
      "appCode": "bjia_org",
      "eventAction": "view",
      "eventCategory": "view",
    }
  } else if (!params.url) {
    //params.url = window.location.href;
  }

  const AUTH_TOKEN = getCookie('sd_token');
  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    'User-Authorization': AUTH_TOKEN,
  };
  axios.post('https://tongji.api.examok.com/api/tongji/push.json', QS.stringify(params), {
      headers
    })
    .then(response => {
      const res = response.data;
      if (res.data == 1) {
        console.log('统计成功');
      } else {
        // _this.$message.error(res.msg);
      }
    })
    .catch(error => {
      // _this.$message.error(error.message);
    });
}